'use client';

import {EditorEvents} from '@tiptap/core';
import {EditorProvider} from '@tiptap/react';
import {forwardRef, useCallback} from 'react';
import {cn} from '../libs';

import {InlineToolbar} from './components';
import {TiptapPreset} from './types';

interface TiptapProps {
  className?: string;
  preset: TiptapPreset;
  value?: string | null;
  onChange?: (value: string) => void;
}

export const Tiptap = forwardRef<HTMLDivElement, TiptapProps>(function Tiptap(
  {preset, value, onChange, className},
  ref,
) {
  const onUpdate = useCallback(
    ({editor}: EditorEvents['update']) => {
      const isEmpty = editor.getText({blockSeparator: '\n'}) === '';

      switch (preset.format) {
        case 'rich':
          onChange?.(!isEmpty ? editor.getHTML() : '');
          break;
        default:
          onChange?.(!isEmpty ? editor.getText({blockSeparator: '\n'}) : '');
          break;
      }
    },
    [preset, onChange],
  );

  return (
    <div
      ref={ref}
      className={cn(
        'tiptap-inline-prose prose prose-sm md:prose-base w-full max-w-full rounded-sm border border-[transparent] leading-4 transition-all',
        'md:leading-5',
        'focus-within:border',
        'focus-within:bg-bg-primary',
        'focus-within:border-input-border-hover',
        'hover:bg-bg-primary',
        className,
      )}
    >
      <EditorProvider
        editorContainerProps={{
          className: cn(
            preset.format === 'rich' &&
              '[&>.tiptap]:min-h-24 rounded-lg border bg-bg-secondary p-4',
          ),
        }}
        extensions={preset.extensions}
        content={value}
        onUpdate={onUpdate}
      >
        {preset.toolbar === 'inline' && <InlineToolbar />}
      </EditorProvider>
    </div>
  );
});
